import * as yup from 'yup';
import { validateEmail } from 'src/validations';
import { VALIDATION_MESSAGE } from 'src/formMapper';

export const validationSchema = yup
  .object()
  .shape({
    email: validateEmail,
    password: yup.string().required(VALIDATION_MESSAGE.password)
  })
  .defined();
